import DOMPurify from 'dompurify';
import localStorageHelper from 'helpers/localStorageHelper';
import cookieHelper from 'helpers/cookieHelper';
import { defaultLandingPage } from 'routes';


export const mergeUserInfo = (userInfoMicroService) => {
    const hasBroadcastMessage = userInfoMicroService?.broadcastMessages?.length > 0;
    const broadcastMsg = hasBroadcastMessage ? userInfoMicroService.broadcastMessages[0] : null;
    return {
        userRoles: userInfoMicroService?.user?.roles,
        isEULAAccepted: userInfoMicroService?.user?.isEULAAccepted,
        userID: hasBroadcastMessage ? broadcastMsg?.userID : userInfoMicroService?.broadcastMessages,
        languageCode: userInfoMicroService?.language?.code,
        email: userInfoMicroService?.user?.email,
        firstName: userInfoMicroService?.user?.firstName,
        lastName: userInfoMicroService?.user?.lastName,
        measurementUnitGroups: userInfoMicroService?.measurementUnitGroups,
        landingPageId: userInfoMicroService?.landingPage?.id,
        isAdminFromCIAM: userInfoMicroService?.isAdmin,
        //Should be removed after the full switch
        ciamID: userInfoMicroService?.user?.id,
        broadcastMessageID: hasBroadcastMessage && !broadcastMsg?.isDeleted ? broadcastMsg?.broadcastMessageID : null
    };
};

const setLanguageCookie = ({ language }) => {
    const languageCode = language ? language.code : 'en';

    const expirationDate = new Date();
    expirationDate.setFullYear(expirationDate.getFullYear() + 3);

    cookieHelper.setCookie('userLanguage', `c=${languageCode}|uic${languageCode}`, expirationDate);
};

export const setPersistentUserInfo = (userInfoMicroService) => {
    if (userInfoMicroService) {
        localStorageHelper.setItem('user', mergeUserInfo(userInfoMicroService));
        localStorageHelper.setItem('loginTimestamp', new Date().getTime());

        setLanguageCookie(userInfoMicroService);
    }
};


// Getting return url

const popReturnUrl = () => {
    const returnUrl = localStorageHelper.getItem('returnUrl');
    return returnUrl;
};

export const removeReturnUrl = () => {
    localStorageHelper.removeItem('returnUrl');
};

const shouldReturnToLandingPage = (returnUrl) => {
    return !returnUrl
        || returnUrl === '/'
        || returnUrl.toLowerCase() === '/home'
        || returnUrl.toLowerCase() === 'home/index';
};

export const getRedirectUrl = (user, environmentalProperties) => {

    if (user && environmentalProperties) {
        const returnUrl = popReturnUrl();

        if (shouldReturnToLandingPage(returnUrl)) {
            return defaultLandingPage;
        }

        return DOMPurify.sanitize(returnUrl);
    }
    return null;
};

